import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const projectSettingsServicedeskExternalLinksRoute: InvariantJiraRoute = {
	name: 'project-settings-servicedesk-external-links',
	path: '/jira/servicedesk/projects/:projectKey/settings/external-links',
	exact: true,
};
